export default __webpack_public_path__ + "static/media/binance.8fe65579.svg";